import exit from '../../assets/images/icons/exit.svg';
import { Container, MenuItem } from './styles';

import { ReactNode } from 'react';
import { useAppContext } from '../../contexts/auth';
import AdminNavbar from './components/AdminNavbar';
import TeacherNavbar from './components/TeacherNavbar';

interface NavbarInterface {
  active: string;
}


type SidebarPermisionsMapType = {
  [key: string]: ReactNode;
}

export default function Navbar({ active }: NavbarInterface) {
  const { signOut } = useAppContext();
  const appContext = useAppContext();
  const { permission } = appContext.user;

  const sidebarPermissionMap: SidebarPermisionsMapType = {
    super: <AdminNavbar active={active} />,
    teacher: <TeacherNavbar active={active} />,
  };

  return (
    <Container>
      <div style={{ overflow: 'auto' }}>
        {sidebarPermissionMap[permission]}
      </div>

      <MenuItem onClick={() => signOut()}>
        <img src={exit} alt="exit" />
        Sair
      </MenuItem>

    </Container>
  );
}
